import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";
import Cookies from "js-cookie";
import { config } from "../../../config/config";

// AUTH LOGIN
export const loginUser = createAsyncThunk(
  "auth/login",
  async (authData, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.post(
        `/v1/user/login/login_user`,
        authData
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

// AUTH LOGOUT
// In your authApi.js or wherever the thunk is defined
export const logoutUser = createAsyncThunk(
  "auth/logout",
  async (_, thunkAPI) => {
    try {
      const token = Cookies.get("authToken");
      if (!token) throw new Error("No token found");

      const response = await axiosInstanceJson.post(
        `/v1/admin/auth/logoutAuth`,
        {
          currentLoginToken: token,
          deviceName: "Windows", // Hardcoded as "Windows" per your requirement
        }
      );

      Cookies.remove("authToken", {
        path: "/",
        domain: config.domain,
        secure: config.ENVIRONMENT === "prod",
        sameSite: "strict",
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
